import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { PrivyProviders } from "./PrivyProviders";
import "./styles.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <PrivyProviders>
      <App />
    </PrivyProviders>
  </React.StrictMode>
);
